import {FC} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setShippingPackage, setTotalWeight} from 'app/features/orders/redux/fulfillment/orderSlices'
import {RootState} from 'setup'
import ShippingPackages from './ShippingPackages'

const ShippingPackagesContainer: FC = () => {
  const dispatch = useDispatch()
  const totalWeight = useSelector<RootState>(
    ({orders}) => orders.fulfillment.order.totalWeight
  ) as any

  const shippingPackage = useSelector<RootState>(
    ({orders}) => orders.fulfillment.order.shippingDefinition.package
  ) as any

  const handleChange = (shippingPackage: any) => {
    dispatch(setShippingPackage(shippingPackage))
  }

  return (
    <ShippingPackages
      totalWeight={totalWeight}
      shippingPackage={shippingPackage}
      onTotalWeightChange={setTotalWeight}
      onChange={handleChange}
    />
  )
}

export default ShippingPackagesContainer
